import { useLocation, Outlet } from 'react-router-dom';
import { Nav } from './Nav.jsx';
import { useLenis } from '../hooks/useLenis.js';
import { useCursorGlow } from '../hooks/useCursorGlow.js';
import { usePageMeta } from '../hooks/usePageMeta.js';
import { useScrollLanding } from '../hooks/useScrollLanding.js';
import { PageAnimationsContext, useAnimations, usePageAnimations } from '../hooks/useAnimations.js';

export default function Layout() {
  const lenisReady = useLenis();
  useCursorGlow();
  const { pathname, hash } = useLocation();
  usePageMeta(pathname);
  const pageAnimations = usePageAnimations();
  // Keep useScrollLanding before useAnimations: when the content is already
  // in, its layout effect lands the page first, so the page animations set up
  // their triggers from there.
  useScrollLanding(pathname, hash, pageAnimations);
  useAnimations(pageAnimations, pathname, lenisReady);

  return (
    <>
      <Nav />
      {/* Target of the "Skip to content" link in index.html. tabIndex=-1 lets
          the jump move focus here without adding the wrapper to tab order. */}
      <div id="main" tabIndex={-1}>
        {/* Each page's PageReady reports here once its content is in the DOM. */}
        <PageAnimationsContext value={pageAnimations}>
          <Outlet />
        </PageAnimationsContext>
      </div>
    </>
  );
}
